import * as React from 'react';

import type { InjectedIntlProps } from 'react-intl';
import { FormattedMessage, injectIntl } from 'react-intl';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
import styled from 'styled-components';
import { useIntl } from 'react-intl-next';
import { NoteContent } from 'view/layout/note-content';
import SectionMessage from '@atlaskit/section-message';
import { h600, h700 } from '@atlaskit/theme/typography';
import { token } from '@atlaskit/tokens';
import { DocumentTitle } from '@atlassian/help-center-common-component/document-title';
import {
    LetUsKnowLinkText,
    RefreshPageLinkText,
    TellUsAboutIssueLinkText,
} from '@atlassian/help-center-common-component/flag-group';
import { FireScreenEventOnMount } from '@atlassian/help-center-common-util/analytics/fire-screen-event';
import type { DefaultError } from '@atlassian/help-center-common-util/errors';
import { reload } from '@atlassian/help-center-common-util/location';
import { InvitedSignUpForm } from '../invited-sign-up-form';
import messages from './messages';

interface InvitedSignUpStatelessProps {
    email: string;
    isLoading: boolean;
    helpCenterName: string;
    submitError?: DefaultError;
    contactLink: string;
}
const SubmitError = (props: InvitedSignUpStatelessProps) => {
    const { submitError, contactLink } = props;
    const { formatMessage } = useIntl();
    if (submitError) {
        return (
            <SectionMessage appearance="error">
                <FormattedMessage
                    {...submitError.description}
                    values={{
                        refreshLink: (
                            // Disabling existing violations, should be fixed when revisited.
                            // eslint-disable-next-line jsx-a11y/anchor-is-valid
                            <a href="#" onClick={reload}>
                                {formatMessage(RefreshPageLinkText)}
                            </a>
                        ),
                        // Remove contactAdminLink on FF Cleanup
                        contactAdminLink: <a href={contactLink}>{formatMessage(TellUsAboutIssueLinkText)}</a>,
                        contactAdminLinkUnified: <a href={contactLink}>{formatMessage(LetUsKnowLinkText)}</a>,
                    }}
                />
            </SectionMessage>
        );
    }
    return null;
};

export class InvitedSignUpStateless extends React.Component<InvitedSignUpStatelessProps & InjectedIntlProps> {
    render() {
        const { intl, isLoading, email, helpCenterName } = this.props;

        return (
            <DocumentTitle title={intl.formatMessage(messages.documentTitle)}>
                <NoteContent isLoading={isLoading}>
                    <FireScreenEventOnMount />
                    <Title>{helpCenterName}</Title>
                    <SubmitError {...this.props} />
                    <SubTitle>{intl.formatMessage(messages.signUpToContinue)}</SubTitle>
                    <InvitedSignUpForm email={email} />
                </NoteContent>
            </DocumentTitle>
        );
    }
}

export default injectIntl(InvitedSignUpStateless);

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const Title = styled.div`
    ${h700};
    margin-bottom: ${token('space.300', '24px')};
`;

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const SubTitle = styled.div`
    ${h600};
    margin-bottom: ${token('space.050', '4px')};
`;
